import { reducer as formReducer } from 'redux-form';

export const form = formReducer;
